let initial = [];

function listConsultingCategories(state = initial, action) {
  switch (action.type) {
    case 'UPDATE_CONSULTING_CATEGORIES_LIST':
      return action.categories;
    default:
      return state;
  }
}

export {listConsultingCategories}



// WEBPACK FOOTER //
// ./reducers/consulting-categories.js